import { Component, OnInit, HostBinding, Input } from '@angular/core';
import { FormParams } from '../../../interfaces/form-params';

@Component({
  selector: 'bm-date-form',
  templateUrl: './date-form.component.html',
  styleUrls: ['./date-form.component.scss']
})
export class DateFormComponent implements OnInit {

  @HostBinding('class')
  @Input() className = '';

  @Input() params: FormParams;

  constructor() {}

  ngOnInit() {}
}
